import React from "react";

const LoadingState = ({ isDarkMode }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full absolute inset-0">
      {/* Logo with pulsing glow */}
      <div className="relative mb-8">
        {/* Pulsing glow behind logo */}
        <div
          className={`absolute inset-0 rounded-2xl blur-xl animate-pulse ${
            isDarkMode ? "bg-white/10" : "bg-gray-400/20"
          }`}
          style={{ animationDuration: "2s" }}
        />

        {/* Logo container */}
        <div className={`relative w-16 h-16 rounded-2xl overflow-hidden ${
          isDarkMode ? "bg-white shadow-lg shadow-white/5" : "bg-white shadow-xl shadow-gray-300/50"
        }`}>
          <img
            src="/logo-128.png"
            alt="Logo"
            className="w-full h-full p-2"
          />
        </div>
      </div>

      {/* Brand name */}
      <div className="text-center mb-6">
        <h2 className={`text-xl font-semibold tracking-tight ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}>
          Ultimate Web Scraper
        </h2>
        <p className={`text-sm mt-1 ${
          isDarkMode ? "text-gray-500" : "text-gray-400"
        }`}>
          Cloud Data
        </p>
      </div>

      {/* Horizontal loading bar */}
      <div className={`w-48 h-1 rounded-full overflow-hidden ${
        isDarkMode ? "bg-white/10" : "bg-gray-200"
      }`}>
        <div
          className={`h-full rounded-full ${isDarkMode ? "bg-white/60" : "bg-gray-400"}`}
          style={{
            width: "30%",
            animation: "loading-bar 1.2s ease-in-out infinite",
          }}
        />
      </div>

      {/* Loading text */}
      <p className={`mt-4 text-sm ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
        Loading your data...
      </p>

      {/* CSS for loading bar animation */}
      <style>{`
        @keyframes loading-bar {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(250%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingState;
